<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    id="Multicolor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 112">
    <title>01- iphone</title>
    <g id="Background">
      <g
        id="New_Symbol_51-4"
        data-name="New Symbol 51">
        <circle
          class="cls-1"
          cx="50"
          cy="56"
          r="40" />
      </g>
    </g>
    <g id="Scene">
      <path
        class="cls-2"
        d="M63.89,73.68A3.87,3.87,0,0,1,60,77.55H40a3.87,3.87,0,0,1-3.87-3.87v-43A3.87,3.87,0,0,1,40,26.83H60a3.87,3.87,0,0,1,3.87,3.87Z" />
      <path
        class="cls-3"
        d="M63.89,30.7A3.87,3.87,0,0,0,60,26.83H40a3.87,3.87,0,0,0-3.87,3.87v2.41A3.86,3.86,0,0,1,40,29.25H60a3.86,3.86,0,0,1,3.87,3.86Z" />
      <ellipse
        class="cls-4"
        cx="50"
        cy="84.19"
        rx="22.94"
        ry="1.81" />
      <path
        class="cls-5"
        d="M63.89,73.68A3.87,3.87,0,0,1,60,77.55H40a3.87,3.87,0,0,1-3.87-3.87v-43A3.87,3.87,0,0,1,40,26.83H60a3.87,3.87,0,0,1,3.87,3.87Z" />
      <rect
        class="cls-6"
        x="38.53"
        y="34.08"
        width="22.94"
        height="35.62" />
      <polygon
        class="cls-7"
        points="38.53 53.32 57.77 34.08 38.53 34.08 38.53 53.32" />
      <rect
        class="cls-5"
        x="38.53"
        y="34.08"
        width="22.94"
        height="35.62" />
      <line
        class="cls-5"
        x1="48.79"
        y1="30.46"
        x2="55.43"
        y2="30.45" />
      <path
        class="cls-8"
        d="M45.17,29.85h0a.61.61,0,0,0,0,1.21h0a.61.61,0,0,0,0-1.21Z" />
      <circle
        class="cls-9"
        cx="50"
        cy="73.62"
        r="2.11" />
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  .cls-1 {
    fill: #e8f4fa;
  }

  .cls-2 {
    fill: #f0f0f0;
  }

  .cls-3,
  .cls-9 {
    fill: #fff;
  }

  .cls-4,
  .cls-8 {
    fill: #191816;
  }

  .cls-4 {
    opacity: 0.15;
  }

  .cls-5 {
    fill: none;
  }

  .cls-5,
  .cls-9 {
    stroke: #191816;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .cls-6 {
    fill: #00b8f0;
  }

  .cls-7 {
    fill: #4acfff;
  }
</style>
